import { Stack } from '@mantine/core';
import { IterateStep } from '@/types/automationSteps.ts';
import StepCommonFields from '@/pages/Editor/components/SharedFields/StepCommonFields.tsx';
import SingleDataInputSelector from '@/pages/Editor/components/SharedFields/DataInputSelector/SingleDataInputSelector.tsx';
import IterateFields from '@/pages/Editor/components/StepSidebar/StepForms/IterateStep/IterateFields.tsx';
import * as React from 'react';
import StepAdvancedConfigFields from '@/pages/Editor/components/SharedFields/StepAdvancedConfigFields.tsx';

type props = {
  step: IterateStep;
};

export function IterateForm({ step }: props) {
  return (
    <Stack gap="md">
      <StepCommonFields step={step} nameLabel={'Step Name'} />
      <SingleDataInputSelector step={step} />
      <IterateFields step={step} />
      {/*<OutputNameField step={step} />*/}
      <StepAdvancedConfigFields step={step} />
    </Stack>
  );
}
